import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";

import { EcertDateComponent } from "./ecertnl-date/ecertnl-date.component";
import { EcertAutocompleteComponent } from "./ecertnl-autocomplete/ecertnl-autocomplete.component";
import { DateHeaderComponent } from "./ecertnl-date-header/ecertnl-date-header.component";
import { EcertInputComponent } from "./ecertnl-input/ecertnl-input.component";
import { EcertConfirmModalComponent } from "@modals/ecertnl-confirm-modal/ecertnl-confirm-modal.component";
import { EcertDialogData } from "@modals/ecertnl-dialog-data.model";
import { IconComponent } from "./ecertnl-icon/ecertnl-icon.component";
import { EcertSelectComponent } from "./ecertnl-select/ecertnl-select.component";
import { EcertKolommenInstellenComponent } from "./ecertnl-kolommen-instellen/ecertnl-kolommen-instellen.component";
import { GlobalServicesModule } from "../global_services/global-services.module";

@NgModule({
  declarations: [
    EcertConfirmModalComponent,
    EcertDateComponent,
    EcertAutocompleteComponent,
    DateHeaderComponent,
    EcertInputComponent,
    EcertKolommenInstellenComponent,
    IconComponent,
    EcertSelectComponent
  ],
  exports: [
    EcertConfirmModalComponent,
    EcertDateComponent,
    EcertAutocompleteComponent,
    DateHeaderComponent,
    EcertInputComponent,
    EcertKolommenInstellenComponent,
    IconComponent,
    EcertSelectComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    RouterModule,
    ReactiveFormsModule,
    GlobalServicesModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class BuildingBlocksModule {}
